import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: ['myBenefits/historical'],
        config: {
            field: 'Plan',
            headerName: getLocalizedString("plan"),
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: 'Código de empleado',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            headerName: getLocalizedString("nameAndSurname"),
            field: 'Apellido y Nombres',
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            headerName: getLocalizedString("state"),
            field: 'Estado',
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            field: 'Fecha de solicitud',
            headerName: getLocalizedString("requestDate"),
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            field: 'Puntos canjeados',
            headerName: getLocalizedString("redeemedPoints"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            field: 'Tipo de canje',
            headerName: getLocalizedString("redemptionType"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            field: 'Beneficio',
            headerName: getLocalizedString("benefit"),
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            headerName: getLocalizedString("employeesProcessAmount"),
            field: 'Cantidad',
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(0, 0),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: ['myBenefits/historical'],
        config: {
            field: 'Valor del beneficio',
            headerName: getLocalizedString("benefitValue"),
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },

]